export const freezeRiskyPrototypes = () => {
  if (Object.freeze && XMLHttpRequest) {
    Object.freeze(XMLHttpRequest.prototype); // to prevent a prototype pollution attack to get the auth token from the headers
  }
};
